/**
 * @generated SignedSource<<b41452041100b073cba1e0fae01ff421>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type createExternalLicenseRewardButton_ExternalLicensePoolsConnectionFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
    };
  } | null> | null;
  readonly " $fragmentType": "createExternalLicenseRewardButton_ExternalLicensePoolsConnectionFragment";
};
export type createExternalLicenseRewardButton_ExternalLicensePoolsConnectionFragment$key = {
  readonly " $data"?: createExternalLicenseRewardButton_ExternalLicensePoolsConnectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"createExternalLicenseRewardButton_ExternalLicensePoolsConnectionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "createExternalLicenseRewardButton_ExternalLicensePoolsConnectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ExternalLicensePoolsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ExternalLicensePool",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ExternalLicensePoolsConnection",
  "abstractKey": null
};

(node as any).hash = "ce369bec27220ed9f031493b605f7baf";

export default node;
